import { render, staticRenderFns } from "./checkInfo.vue?vue&type=template&id=3db1f658&scoped=true&"
import script from "./checkInfo.vue?vue&type=script&lang=js&"
export * from "./checkInfo.vue?vue&type=script&lang=js&"
import style0 from "./checkInfo.vue?vue&type=style&index=0&id=3db1f658&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db1f658",
  null
  
)

export default component.exports